import React, { Component } from 'react';
import classes from './MixerControl.module.css';
import { BODY_PARTS } from '../../../containers/PixelMixer/PixelMixer';
import { champions } from '../../../assets/data/champions';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import { trackMixerEvent } from '../../../analytics/mixers';

class MixerControl extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  options = () => {
    return champions.map((c) => {
      const type = this.props.bodyPart === BODY_PARTS.HEAD2 ? BODY_PARTS.HEAD : this.props.bodyPart;
      if (this.props.champData.some(part => part.id === c.compValue && part.type === type)) {
        return (
          <option key={c.compValue + '_' + this.props.bodyPart} value={c.compValue + '_' + this.props.bodyPart}>
            {c.name}
          </option>
        );
      }
      return null;
    });
  };

  onRandomize = (track = false) => {
    const type = this.props.bodyPart === BODY_PARTS.HEAD2 ? BODY_PARTS.HEAD : this.props.bodyPart;
    const choices = this.props.champData.filter(part => part.type === type && part.id !== this.props.val);
    const part = this.randomItemFrom(choices);
    if (part) {
      this.props.changeHandler({ target: { value: `${part.id}_${this.props.bodyPart}` } });
      if (track) trackMixerEvent('mixer_randomized', { scope: this.props.bodyPart });
    }
  };
  onSelect = (event) => {
    this.props.changeHandler(event);
    trackMixerEvent('mixer_part_selected', { part: this.props.bodyPart, hero: event.target.value.split('_')[0] });
  };
  randomOptionFrom = (select) => {
    return this.randomItemFrom(select.options);
  };
  randomItemFrom = (arr) => {
    return arr[Math.floor(Math.random() * arr.length)];
  };

  render() {
    return (
      <div className={classes.ControlGroup}>
        <label htmlFor={this.props.bodyPart}>Select {this.props.bodyPart}</label>
        {/* <select
          id={this.props.bodyPart}
          ref={this.selectRef}
          onChange={this.onSelect}
          value={this.props.val + "_" + this.props.bodyPart}
        >

        </select> */}

        <Select
          native
          id={this.props.bodyPart}
          ref={this.selectRef}
          onChange={this.onSelect}
          value={this.props.val + '_' + this.props.bodyPart}
          inputProps={{
            name: this.props.bodyPart,
            id: this.props.bodyPart,
          }}
        >
          {this.options()}
        </Select>
        {/* <button>Randomize</button> */}
        <Button onClick={() => this.onRandomize(true)} variant="outlined">
          Randomize
        </Button>
      </div>
    );
  }
}

export default MixerControl;
